import React, { Component } from "react";
import BootstrapTable from 'react-bootstrap-table-next';
import {SetUser } from "../../../actions/loading";
import { connect } from "react-redux";

class UserGrid extends Component {
    constructor(...args) {
        super(...args);
        this.state = {
            showBanner: false, message: ''
        };
    }
    selectRow = {
        mode: 'radio',
        clickToSelect: true,
        hideSelectColumn: true,
        onSelect: (row, isSelect, rowIndex, e) => {
            this.props.SetUser(row);
        }
    };
    render() {
        return (
            <BootstrapTable
                striped
                data={this.props.searchuserdata}
                columns={this.props.OrderColumns}
                keyField="ID"
                selectRow={this.selectRow}
            />
            );
    }
}

var cpf = connect(state => ({
    loading : state.loading,
    searchuserdata : state.User.data
}),{SetUser})(UserGrid);    
export default cpf;
